/* mx-irmas — "Temos esta carta em outras edicoes" (MoxLand)
   Le o indice de busca que a loja ja usa e, na pagina de um
   produto ESGOTADO, mostra as versoes com estoque. */
(function () {
  if (window.__mxIrmasInit) return;
  window.__mxIrmasInit = true;

  var raiz = document.querySelector('[data-mx-irmas]');
  if (!raiz) return;

  var MAX = 6;
  var nomeAlvo = raiz.getAttribute('data-nome') || '';
  var idAtual = raiz.getAttribute('data-produto') || '';
  var fatias = [];
  try {
    fatias = JSON.parse(raiz.getAttribute('data-fatias') || '[]');
  } catch (e) { return; }
  if (!nomeAlvo || !fatias.length) return;

  function limpar(s) {
    return String(s || '').replace(/\(.*?\)/g, '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  /* nome_en do indice: "Emeritus of Conflict // Lightning Bolt"
     e' carta de dupla face — vale a PRIMEIRA face, nao a
     embutida. */
  function chaveIndice(t) {
    return limpar(String(t || '').split('//')[0]);
  }

  /* titulo do produto: "Raio / Lightning Bolt" e' PT / EN —
     vale o lado ingles. Mas "A // B" e' dupla face. */
  function chave(t) {
    var s = String(t || '');
    if (s.indexOf('//') >= 0) {
      s = s.split('//')[0];
      var p0 = s.split(' / ');
      return limpar(p0[p0.length - 1]);
    }
    var p = s.split(' / ');
    return limpar(p[p.length - 1]);
  }

  var alvo = chave(nomeAlvo);
  if (alvo.length < 4) return;

  function dinheiro(v) {
    return 'R$ ' + Number(v).toFixed(2).replace('.', ',');
  }

  function montar(achados) {
    if (!achados.length) return;
    achados.sort(function (a, b) { return a.preco - b.preco; });
    var mostrar = achados.slice(0, MAX);

    var h = '<div class="mx-irmas-topo">' +
      '<strong>Temos esta carta em outras edições</strong>' +
      '</div><div class="mx-irmas-lista">';

    mostrar.forEach(function (x) {
      h += '<div class="mx-irmas-item">' +
        '<div class="mx-irmas-info">' +
        '<a href="/products/' + x.handle + '">' +
        x.edicao + '</a>' +
        '<span>' + x.acab + ' · ' + x.est +
        (x.est > 1 ? ' em estoque' : ' em estoque') + '</span>' +
        '</div>' +
        '<span class="mx-irmas-preco money">' +
        dinheiro(x.preco) + '</span>' +
        '<button type="button" class="button button-2" ' +
        'data-mx-irma-add="' + x.vid + '">Adicionar</button>' +
        '</div>';
    });
    h += '</div>';

    if (achados.length > MAX) {
      h += '<a class="mx-irmas-todas" href="/search?q=' +
        encodeURIComponent(nomeAlvo.split('/').pop().trim()) +
        '">Ver todas as ' + achados.length + ' versões</a>';
    }
    raiz.innerHTML = h;
    raiz.style.display = 'block';
  }

  /* posicoes do indice (gerar_indice_busca.py v3):
     0 nome_pt | 1 nome_en | 2 set | 3 numero | 4 raridade
     5 cores | 6 identidade | 7 tipos
     8 preco_normal | 9 preco_foil
     10 estoque_normal | 11 estoque_foil
     12 handle | 13 palavras | 14 vid_normal | 15 vid_foil */
  function achar(lista) {
    var saida = [];
    lista.forEach(function (c) {
      if (!c || c.length < 16) return;
      if (chaveIndice(c[1]) !== alvo) return;
      var handle = c[12];
      if (!handle || handle === idAtual) return;
      var sc = c[2] || '';
      var edicao = (window.__mxSets && window.__mxSets[sc])
        ? window.__mxSets[sc] : sc.toUpperCase();
      var est_n = Number(c[10] || 0);
      var est_f = Number(c[11] || 0);
      if (est_n > 0) {
        saida.push({ handle: handle, edicao: edicao,
                     preco: Number(c[8] || 0), acab: 'Normal',
                     est: est_n, vid: c[14] || '' });
      }
      if (est_f > 0) {
        saida.push({ handle: handle, edicao: edicao,
                     preco: Number(c[9] || 0), acab: 'Foil',
                     est: est_f, vid: c[15] || '' });
      }
      /* campo 17: acabamentos especiais COM estoque, cada um vira
         uma linha com o rotulo VERDADEIRO (Silver Scroll, Surge Foil,
         Etched...). Vazio na maioria das cartas. A pseudo-carta do
         indice generico nao tem esse campo — o `|| []` cobre. */
      (c[16] || []).forEach(function (x) {
        if (!x || !(Number(x[2]) > 0)) return;
        saida.push({ handle: handle, edicao: edicao,
                     preco: Number(x[1] || 0), acab: String(x[0] || ''),
                     est: Number(x[2]), vid: x[3] || '' });
      });
    });
    return saida;
  }

  var arqMeta = raiz.getAttribute('data-arq-meta') || '';
  if (arqMeta && !window.__mxSets) {
    fetch(arqMeta).then(function (r) { return r.json(); })
      .then(function (m) {
        window.__mxSets = {};
        var s = m && (m.sets || m.s);
        if (s) {
          Object.keys(s).forEach(function (k) {
            window.__mxSets[k] = (s[k][1] || s[k][0] || k);
          });
        }
      }).catch(function () { /* sem nome bonito de edicao */ });
  }

  /* le as fatias em paralelo, monta assim que todas chegarem */
  Promise.all(fatias.map(function (u) {
    return fetch(u).then(function (r) { return r.json(); })
      .catch(function () { return null; });
  })).then(function (partes) {
    var achados = [];
    partes.forEach(function (p) {
      if (!p || !Array.isArray(p)) return;
      achados = achados.concat(achar(p));
    });
    var vistos = {}, limpos = [];
    achados.forEach(function (x) {
      var k = x.handle + '|' + x.acab;
      if (vistos[k]) return;
      vistos[k] = 1;
      limpos.push(x);
    });
    montar(limpos);
  }).catch(function () { /* silencio: bloco so' nao aparece */ });

  document.addEventListener('click', function (e) {
    var b = e.target.closest ?
      e.target.closest('[data-mx-irma-add]') : null;
    if (!b) return;
    e.preventDefault();
    var vid = b.getAttribute('data-mx-irma-add');
    if (!vid) return;
    var txt = b.textContent;
    b.textContent = 'Adicionando...';
    b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid),
                                       quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw res;
        b.textContent = 'No carrinho ✓';
        /* abre a gaveta do tema, igual ao botao nativo */
        var item = (res.items && res.items[0]) || res;
        if (window.Shopify &&
            typeof window.Shopify.onItemAdded === 'function') {
          try {
            window.Shopify.onItemAdded(item);
          } catch (err) {
            window.location.href = '/cart';
          }
        } else {
          window.location.href = '/cart';
        }
        setTimeout(function () {
          b.textContent = txt;
          b.disabled = false;
        }, 2500);
      }).catch(function () {
        b.textContent = txt;
        b.disabled = false;
      });
  });
})();
